<header class="layout__header medium-type fill border-bottom white-bg nordic-blue-900-text">
  <fin-header-boxes [showLink]="false">
    <div left class="header-box-height"></div>
  </fin-header-boxes>
</header>
